<template>
    <div class="h-100 d-flex justify-content-center align-items-center" v-if="loadingDashboard">
        <vue-loaders-ball-beat scale="2" color="black" />
    </div>
    <div v-else>
        <div style="clear:both; border-bottom:solid 1px #ccc; margin-top:1rem;">
            <a v-on:click="changeTab('n')">
                <button :class="[tabStatus === 'n' ? 'dashTab-selected' : 'dashTab']" class="newTab">NEW SUBMISSIONS</button>
            </a>
            <a v-on:click="changeTab('p')">
                <button :class="[tabStatus === 'p' ? 'dashTab-selected' : 'dashTab']" class="outForApprovalTab">OUT FOR APPROVAL</button>
            </a>
            <a v-on:click="changeTab('a')">
                <button :class="[tabStatus === 'a' ? 'dashTab-selected' : 'dashTab']" class="approvedTab">APPROVED</button>
            </a>
            <a v-on:click="changeTab('e')">
                <button :class="[tabStatus === 'e' ? 'dashTab-selected' : 'dashTab']" class="erpTab">ENTERED INTO ERP</button>
            </a>
            <a v-on:click="changeTab('d')">
                <button :class="[tabStatus === 'd' ? 'dashTab-selected' : 'dashTab']" class="deniedTab">DENIED</button>
            </a>
        </div>
        <br>
        <priceworkflow-dashboard-pagination
            :totalSubmissions="totalSubmissions"
            :previousPageLink="previousPageLink"
            :nextPageLink="nextPageLink"
            :currPage="currPage"
            :totalPages="totalPages"
            @change-page="changePage"
        ></priceworkflow-dashboard-pagination>
        <br>
        <button v-on:click="clearFilters()" class="btn-round-red" type="button">Clear Filters</button>
        <br><br>
        <table class="submissionTBL">
            <tr class="TBLhead">
                <th v-if="bulkActionsAvailable" style="width:5%;">BULK SELECT</th>
                <th style="width:8%;">{{ submittedColHeader }}</th>
                <th style="width:5%;">
                    <a id="btFil" style="cursor:pointer;" v-on:click="toggleFilterField('bt')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayBtFilter" id="btHeader">BT</span>
                    <span v-else id="btFilterField">
                        <input id="btField" type="text" v-model="filters.bt" placeholder="BT Filter" style="width:80%;" />
                    </span>
                </th>
                <th style="width:12%;">
                    <a id="companyFil" style="cursor:pointer;" v-on:click="toggleFilterField('company')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayCompanyFilter" id="companyHeader">COMPANY</span>
                    <span v-else id="companyFilterField">
                        <input id="companyField" type="text" v-model="filters.company" placeholder="Company Filter" style="width:80%;" />
                    </span>
                </th>
                <th v-if="tabStatus == 'p'" style="width:8%;">
                    <a id="currStepFil" style="cursor:pointer;" v-on:click="toggleFilterField('currStep')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayCurrStepField" id="currStepHeader">CURRENT STEP</span>
                    <span v-else id="currStepFilterField">
                        <admin-select id="currStepField" v-model="filters.currStep" style="width:80%;">
                            <option value="">Current Step Filter</option>
                            <option :value="1">RSM</option>
                            <option :value="2">SD</option>
                            <option :value="3">VP</option>
                            <option :value="4">EXEC</option>
                        </admin-select>
                    </span>
                </th>
                <th style="width:12%;">RATIONALE</th>
                <th style="width:8%;">CURRENT LEVEL</th>
                <th style="width:8%;">SUGGESTED LEVEL</th>
                <th style="width:8%;">DISCOUNT AMOUNT</th>
                <th style="width:8%;">DISCOUNT TYPE</th>
                <th style="width:7%;">6M SALES</th>
                <th style="width:7%;">12M SALES</th>
                <th colspan="3" style="text-align:center;width:10%;">ACTIONS</th>
            </tr>
            <tr v-for="entry in submissions">
                <td v-if="bulkActionsAvailable">
                    <!-- {{ entry.id }} -->
                    <input v-if="((tabStatus == 'n' && entry.suggested_lvl) || (tabStatus == 'p' && entry.canBeSignedOffOn) || (tabStatus == 'a'))" type="checkbox" class="submissionId" :value="entry.id" v-model="selectedIds" />
                    <input v-else type="checkbox" disabled="disabled" style="cursor:not-allowed;" />
                </td>
                <td>{{ entry.timestamp }}</td>
                <td>{{ entry.cust_id }}</td>
                <td>{{ entry.company }}</td>
                <td v-if="tabStatus == 'p'" style="text-transform:uppercase;">{{ entry.currentStep }}</td>
                <td>{{ entry.rationale }}</td>
                <td>{{ entry.price_level }}</td>
                <td v-if="entry.act_id == 3">{{ entry.suggested_lvl }}</td>
                <td v-else>N/A</td>
                <td v-if="entry.act_id == 7">{{ entry.discount_amount }}%</td>
                <td v-else>N/A</td>
                <td v-if="entry.act_id == 7">{{ entry.discount_type }}</td>
                <td v-else>N/A</td>
                <td>${{ entry.sales_6m }}</td>
                <td>${{ entry.sales_12m }}</td>
                <td v-if="tabStatus == 'n' && entry.suggested_lvl != null && entry.suggested_level != ''" id="iconTd">
                    <a v-on:click="submitEntry(entry.id, entry.act_id)">
                        <img id="iconImg" src="/images/icon-circle-submit.png" />
                    </a>
                    <p id="iconLabel">SUBMIT</p>
                </td>
                <td v-else-if="tabStatus != 'n'" id="iconTd">
                    <router-link v-if="entry.act_id == 3" :to="{ name: 'PriceLevelSignoff', params: {ppId: entry.id}}">
                        <img id="iconImg" src="/images/icon-circle-view-green.png" />
                    </router-link>
                    <router-link v-else :to="{ name: 'PriceWorkflowCustomDiscountSignoff', params: {ppId: entry.id}}">
                        <img id="iconImg" src="/images/icon-circle-view-green.png" />
                    </router-link>
                    <p id="iconLabel">VIEW</p>
                </td>
                <td v-else id="iconTd">
                    &nbsp;
                </td>
                <td v-if="tabStatus == 'n' || (tabStatus == 'd' && entry.edittableByCurrUser)" id="iconTd">
                    <router-link v-if="entry.act_id == 3" :to="{ name: 'PriceWorkflowLevelDeviation', params: {ppId: entry.id}}">
                        <img id="iconImg" src="/images/icon-circle-edit.png" />
                    </router-link>
                    <router-link v-else :to="{ name: 'PriceWorkflowCustomDiscount', params: {ppId: entry.id}}">
                        <img id="iconImg" src="/images/icon-circle-edit.png" />
                    </router-link>
                    <p id="iconLabel">EDIT</p>
                </td>
                <td v-if="tabStatus == 'n' || (user.user_group_id != 10)" id="iconTd">
                    <a v-on:click="deleteEntryEmitter(entry.id)">
                        <img id="iconImg" src="/images/icon-circle-trash.png" />
                    </a>
                    <p id="iconLabel">DELETE</p>
                </td>
            </tr>
        </table>
        <ul v-if="bulkActionsAvailable" id="bulkActionUl">
            <li style="border-right: 1px solid black; padding-right:10px;">
                <input type="checkbox" id="checkAll" v-on:click="checkAll()" style="padding: 0 10px 0 1px; color:#999;"> SELECT ALL
            </li>
            <li>
                <span><strong>BULK ACTIONS: </strong></span>
            </li>
            <li v-if="tabStatus == 'a'">
                <button 
                    @click="getConfirmation('bulkErp', 'e');" 
                    class="btn-round-green" 
                    type="button" 
                    :disabled="loadingBulkAction"
                    style="margin-top:0;"
                >
                    APPROVE ERP
                </button>
            </li>
            <li v-if="tabStatus == 'n' || tabStatus == 'p' || tabStatus == 'a'">
                <button 
                    @click="getConfirmation('bulkDelete', 'd');" 
                    class="btn-round-red" 
                    type="button" 
                    :disabled="loadingBulkAction"
                    style="margin-top:0;"
                >
                    DELETE
                </button>
            </li>
            <li v-if="loadingBulkAction">
                <vue-loaders-ball-beat scale="1" color="black" />
            </li>
        </ul>
        <br>
        <priceworkflow-dashboard-pagination
            :totalSubmissions="totalSubmissions"
            :previousPageLink="previousPageLink"
            :nextPageLink="nextPageLink"
            :currPage="currPage"
            :totalPages="totalPages"
            @change-page="changePage"
        ></priceworkflow-dashboard-pagination>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            bulkActionsAvailable: false,
            bulkSelect: [],
            currPage: "",
            displayBtFilter: false,
            displayCompanyFilter: false,
            displayCurrStepField: false,
            filters: {
                bt: "",
                company: "",
                currStep: ""
            },
            isAdmin: false,
            loadingBulkAction: false,
            loadingDashboard: true,
            nextPageLink: "",
            paginationResults: {},
            previousPageLink: "",
            selectedIds: [],
            submissions: [],
            submittedColHeader: "STARTED",
            tabStatus: this.$route.params.status || "n",
            totalPages: "",
            totalSubmissions: "",
        }
    },
    created() {
        if(this.user != null && this.user.user_group_id != null) {
            this.getPaginationResults();
        }

        this.$parent.$on('triggerLevelDeviationDashboardRefresh', () => {
            // Reset checkboxes and selectedIds
            $('#checkAll').prop('checked', false);
            $('.submissionId').prop('checked', false);
            this.selectedIds = [];

            this.getPaginationResults();
        });
    },
    watch: {
        paginationResults() {
            this.submissions = this.paginationResults['data'];
            this.totalSubmissions = this.paginationResults['total'];
            this.currPage = this.paginationResults['current_page'];
            this.totalPages = this.paginationResults['last_page'];
            this.previousPageLink = this.paginationResults['prev_page_url'];
            this.nextPageLink = this.paginationResults['next_page_url'];

            this.loadingDashboard = false;
            this.loadingBulkAction = false;
        },
        user () {
            this.getPaginationResults();
        },
        tabStatus: {
            handler() {
                $(".dashTab-selected").attr("class", "dashTab");

                if(this.tabStatus == "n") {
                    $(".newTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "STARTED";
                    this.bulkActionsAvailable = true;
                } else if (this.tabStatus == "p") {
                    $(".outForApprovalTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "SUBMITTED";
                    if(this.user.user_group_id != 10) {
                        this.bulkActionsAvailable = true;
                    } else {
                        this.bulkActionsAvailable = false;
                    }
                } else if (this.tabStatus == "a") {
                    $(".approvedTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "SUBMITTED";
                    if(this.priceERPAdmins.includes(this.user.id)) {
                        this.bulkActionsAvailable= true;
                    } else {
                        this.bulkActionsAvailable = false;
                    }
                } else if (this.tabStatus == "e") {
                    $(".erpTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "ENTERED";
                    this.bulkActionsAvailable = false;
                } else if (this.tabStatus == "d") {
                    $(".deniedTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "SUBMITTED";
                    this.bulkActionsAvailable = false;
                }
            },
            immediate: true
        },
        selectedIds() {
            if(this.selectedIds.length == $('.submissionId').length) {
                $("#checkAll").prop('checked', true);
            } else {
                $("#checkAll").prop('checked', false);
            }
        },
        filters: {
            handler() {
                this.getPaginationResults();
                this.selectedIds = [];
            },
            deep: true
        }
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            priceDeviationAdmins: state => state.priceDeviationAdmins,
            priceERPAdmins: state => state.priceERPAdmins
        })
    },
    methods: {
        getPaginationResults() {
            axios.get(`/api/getPriceLevelSubmissions/${this.tabStatus}/${this.user.id}/${this.priceDeviationAdmins}`, {
                params: {
                    bt: this.filters.bt,
                    company: this.filters.company,
                    currStep: this.filters.currStep
                }
            }).then(response => {
                this.paginationResults = response.data;
            });
        },
        changePage(link) {
            axios.get(link, {
                params: {
                    bt: this.filters.bt,
                    company: this.filters.company,
                    currStep: this.filters.currStep
                }
            }).then(response => {
                this.paginationResults = response.data;
            });
        },
        changeTab(newStatus) {
            this.tabStatus = newStatus;
            this.clearFilters();
        },
        submitEntry(ppId, actId) {
            axios.post(`/api/submitEntry`, {ppId: ppId}).then(response => {
                if(actId == "3") {
                    this.$router.push({
                        name: "PriceLevelSignoff",
                        params: { ppId: ppId }
                    });
                } else {
                    this.$router.push({
                        name: "PriceWorkflowCustomDiscountSignoff",
                        params: { ppId: ppId }
                    });
                }
            });
        },
        deleteEntryEmitter(ppId) {
            if(confirm("Did you mean to click DELETE? This will remove the selected Price Level Deviation from the database.")) {
                this.$emit('delete-entry', ppId);
            }
        },
        checkAll() {
            if($("#checkAll").prop('checked') == true) {
                this.selectedIds = [];

                for(let submission of this.submissions) {
                    let checkbox = document.querySelector(`input.submissionId[value="${submission.id}"]`);

                    if(checkbox && !checkbox.disabled) {
                        this.selectedIds.push(submission.id);
                    }
                }
            } else {
                this.selectedIds = [];
            }
        },
        getConfirmation(action, status) {
            if($('[class="submissionId"]:checked').length > 0) {
                let confirmMsg = this.getConfirmMsg(action);
                let confirmVal = confirm(confirmMsg);

                if(confirmVal) {
                    this.bulkActionEmitter(action, status);
                } else {
                    return false;
                }
            } else {
                alert("No submissions were selected to take action on.");
            }
        },
        getConfirmMsg(action) {
            if(action == "bulkErp") {
                return "Are you suer you wish to bulk approve the selected items? Once confirmed the databse will be updated for each entry.";
            } else if(action == "bulkDelete") {
                return "Are you sure you want to delete all of the selected items? Once confirmed each entry will be removed and this action cannot be undone.";
            }
        },
        bulkActionEmitter(action, status) {
            this.loadingBulkAction = true;

            this.$emit('bulk-action', {
                action: action,
                signOffStatus: status,
                submissionIds: this.selectedIds,
                userId: this.user.id
            })
        },
        toggleFilterField(filter) {
            // toggle corresponding filter to hide it and show the filter field
            if(filter == "bt") {
                this.displayBtFilter = !this.displayBtFilter;
            } else if(filter == "company") {
                this.displayCompanyFilter = !this.displayCompanyFilter;
            } else if(filter == "currStep") {
                this.displayCurrStepField = !this.displayCurrStepField;
            }
        },
        clearFilters() {
            for(let filter in this.filters) {
                this.filters[filter] = "";
            }

            this.displayBtFilter = false;
            this.displayCompanyFilter = false;
            this.displayCurrStepField = false;

            this.getPaginationResults();
        }
    },
    beforeDestroy() {
        this.$parent.$off('triggerLevelDeviationDashboardRefresh');
    }
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    .TBLhead th {
        font-weight: bold;
        border-bottom: solid 1px #333;
        margin-bottom: 0;
        vertical-align: bottom;
        text-align: left;
    }

    .submissionTBL {
        width: 100%;
        margin: 0;
        text-align: left;
        font-size: 0.9rem;
    }

    #iconImg {
        height:26px; 
        width:auto;
    }

    #iconTd {
        text-align:center; 
        width:2%;
        cursor: pointer;
    }

    #iconLabel {
        font-size:0.6rem; 
        color:#999;
    }

    .dashTab {
        position: relative;
        top: 1px;
        font-family: Arial;
        font-size: 0.8rem;
        line-height: 1.6rem;
        background: #fff;
        border: solid 1px #ccc;
        padding: 0.8rem 1rem;
        color: #999;
        cursor: pointer;
        width: 11rem;
    }

    .dashTab-selected {
        position: relative;
        top: 1px;
        font-family: Arial;
        font-size: 0.8rem;
        line-height: 1.6rem;
        border: solid 1px #ccc;
        border-left: 0px;
        padding: 0.8rem 1rem;
        cursor: pointer;
        width: 11rem;
        background-color: #cd1b00;
        background: #cd1b00;
        color: #fff;
    }

    .submissionTBL td {
        padding: 1rem .25rem 1rem 0;
        background: #fff;
        border-bottom: dotted 1px #ccc;
    }

    #bulkActionUl {
        list-style-type:none; 
        display:flex; 
        flex-wrap:wrap; 
        align-items:center; 
        margin-top:5px;
    }

    #bulkActionUl li {
        padding-left:10px;
    }
</style>
